module.exports = __webpack_public_path__ + "resources/create-65daf56272a7fe4835c001e37df054bd.svg";